import React, { useEffect } from "react";

const TrustpilotReviews = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(
          document.querySelector(".trustpilot-widget")
        );
      }
    };

    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <div
        class="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="539adbd6dec7e10e686debee"
        data-businessunit-id="62053dd91174fa6f10b67256"
        data-style-height="500px"
        data-style-width="100%"
        data-stars="4,5"
        data-review-languages="en"
        data-theme="dark"
      >
        <a
          href="https://uk.trustpilot.com/review/alphacapitalgroup.uk"
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </a>
      </div>
      {/* <div
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="62053dd91174fa6f10b67256"
        data-style-height="500px"
        data-style-width="100%"
        data-stars="4,5"
        data-theme="dark"
      >
        <a
          href="https://www.trustpilot.com/review/trustpilot.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot
        </a>
      </div> */}
    </>
  );
};

export default TrustpilotReviews;
